<mat-form-field [class]="formFieldClass">
  <mat-label>{{ 'colorLabel' | translate }}</mat-label>
  <mat-select
    [value]="value"
    (selectionChange)="onSelect($event.value)"
    [disabled]="isDisabled">
    @for (color of colorsOptions; track color) {
      <mat-option [value]="color.id">
        <span [ngStyle]="{ color: color.id }">{{
          color.label | translate
        }}</span>
      </mat-option>
    }
  </mat-select>
</mat-form-field>
